import { Link } from '@ta-interaktiv/contentbricks'
import React from 'react'

export const TEXT_DE = {

    title: 'Ihr Alkohol-Konsum im Vergleich',
    lead:
        '  Wie viel Bier, Wein und Schnaps trinken Sie im Vergleich mit den anderen Leserinnen und Lesern? Und ab wann wird es riskant? Unser Alkoholrechner weiss es.',
    date: 'Aktualisiert am 23. Juni 2022',
    intro:
        'Unser interaktives Tool zeigt Ihnen, wie viel Sie im Vergleich zu den anderen Leserinnen und Lesern trinken – und wie Sie im Schweizer Vergleich dastehen.',

    agegroups: {
        age_15_24: '15-24-jährig',
        age_25_34: '25-34-jährig',
        age_35_44: '35-44-jährig',
        age_45_54: '45-54-jährig',
        age_55_64: '55-64-jährig',
        age_65_74: '65-74-jährig',
        age_75: '75+ -jährig'
    },
    calculator: {
        earlyfeedback: (
            <>
                Haben Sie Anmerkungen?{" "}
                <a href='mailto:interaktiv@tamedia.ch?subject=Alkoholrechner'>
                    interaktiv@tamedia.ch
                </a>
            </>
        ),
        select: "Bitte auswählen",
        title: 'Wie viele Standardgläser Alkohol trinken Sie pro Woche?',
        lead: (
            <>
                Ein <b>Standardglas Alkohol</b> enthält zwischen 10 und 12 Gramm reinen
                Alkohol. So viel enthält ungefähr eine Stange Bier (3 Deziliter), ein
                Glas Wein (1 Deziliter) oder ein Gläschen Schnaps (0,3 Deziliter).
            </>
        ),
        drinks: ['Stange Bier', 'Glas Wein', 'Schnaps'],
        questions: [
            ['Ihr Geschlecht? ', 'Frau', 'Mann'],
            [
                'Wie häufig trinken Sie in der Woche?',
                'nie',
                'weniger als 1 Tag pro Woche',
                'an 1 bis 2 Tagen pro Woche',
                'an 3 bis 6 Tagen pro Woche',
                'täglich'
            ],
            [
                'Trinken Sie mindestens einmal im Monat 5 oder mehr Standardgläser (Männer) bzw. 4 oder mehr Standardgläser (Frauen) innerhalb von wenigen Stunden (zum Beispiel an einem Abend)?',
                'Ja',
                'Nein'
            ],
            [
                'Ihre Altersgruppe?',
                '15–24 Jahre',
                '25–34 Jahre',
                '35–44 Jahre',
                '45–54 Jahre',
                '55–64 Jahre',
                '65–74 Jahre',
                '75+ Jahre'
            ]
        ],
        disclaimer:
            'Alle Daten werden ausschliesslich für die Visualisierung verwendet. Sie werden nicht weitergegeben, sind anonym und werden nicht zu persönlichen Daten zugeordnet.',
        buttons: ['Auswerten', 'Danke für Ihre Teilnahme!'],
        fillout: 'Vervollständigen Sie Ihre Angaben um zur Auswertung zu gelangen!'
    },
    risk: {
        otherCats: "Die anderen Risikostufen sind:",
        diclaimer: <>Alle verwendeten Empfehlungen und Einteilungen zum Alkoholkonsum
            stammen vom{' '}
            <Link href='https://www.bag.admin.ch/bag/de/home/gesund-leben/sucht-und-gesundheit/alkohol/problemkonsum.html'>
                Bundesamt für Gesundheit
            </Link>{' '}
            und sind in der internationalen Alkoholforschung etabliert.</>,
        getHelp: <>Falls Sie das Gefühl haben, ein Alkoholproblem zu haben,{' '}
            <Link
                href='https://www.suchtschweiz.ch/ueber-uns/kontakt/'
                allowWordWrap={false}
            >
                finden Sie hier Hilfe.
            </Link></>,
        gender: {
            m: ['Teilnehmer', 'Teilnehmern'],
            f: ['Teilnehmerinnen', 'Teilnehmerinnen']
        },
        user: {
            none: <>Sie sind abstinent oder trinken ganz selten Alkohol.</>,
            low: <>Ihr Konsum ist risikoarm.</>,
            middle: <>Ihr Konsum ist möglicherweise risikoreich.</>,
            high: (
                <>
                    Ihr Konsum ist <b>chronisch oder punktuell risikoreich</b>.
                </>
            )
        },
        frequency: {
            none: 'abstinent leben',
            low: 'riskikoarm trinken',
            middle: 'möglichwerweise risikoreich trinken',
            high: ' risikoreich trinken'
        },
        groups: {
            none: (
                <>
                    <h5>Abstinent</h5>Zu dieser Stufe gehören alle Personen, die keinen
                    Alkohol trinken.
                </>
            ),
            low: (
                <>
                    <h5>Risikoarm</h5>
                    <ul>
                        <li>
                            Wenn <b>Frauen</b> täglich nicht mehr als 1 Standardglas Alkohol
                            (10 bis 12 Gramm) trinken, ist das wenig schädlich. Wenn es
                            ausnahmsweise etwas mehr wird, nicht mehr als 3 Gläser. An
                            mindestens 2 Tagen pro Woche sollte auf Alkohol verzichtet werden.
                        </li>
                        <li>
                            Für <b>Männer</b> liegt die Grenze bei 20 bis 24 Gramm, was 2
                            Standardgläsern Alkohol am Tag entspricht. Wenn es ausnahmsweise
                            an einem Abend mehr wird, nicht mehr als 4 Gläser. Empfohlen sind
                            mindestens 2 Tage Abstinenz pro Woche.
                        </li>
                    </ul>
                    Rund 80 Prozent der in der Schweiz lebenden Bevölkerung im Alter von
                    15 bis 74 Jahren trinken gemäss Bundesamt für Statistik risikoarm bzw.
                    keinen Alkohol.
                </>
            ),
            middle: (
                <>
                    <h5>Möglicherweise risikoreich</h5>
                    In diese Stufe fallen alle Personen die zwischen risikoarm und
                    chronisch risikoreich bzw. punktuell risikoreich liegen.
                </>
            ),
            high: (
                <>
                    <h5>Chronisch risikoreich oder punktuell risikoreich</h5>
                    Von risikoreichem Alkoholkonsum wird dann gesprochen, wenn durch das Konsumieren von Alkohol die eigene Gesundheit oder diejenige anderer Personen gefährdet wird. Es wird zwischen folgenden Konsummustern unterschieden:
                    <ul>
                        <li>
                            <b>Chronisch riskanter Konsum bedeutet:</b> 4 oder mehr Standardgläser eines alkoholischen Getränks täglich bei Männern, 2 oder mehr Gläser bei Frauen.
                        </li>
                        <li>
                            Von <b>punktuell riskantem Konsum oder Rauschtrinken</b> spricht man in der Alkoholforschung, wenn Männer 5 Standardgläser Alkoholisches oder mehr und Frauen 4 Gläser oder mehr innerhalb weniger Stunden mindestens einmal pro Monat trinken.

                        </li>
                    </ul>
                    5% der Schweizerinnen und Schweizer ab 15 Jahren trinken gemäss dem Bundesamt für Statistik chronisch risikoreich, und 20% betrinken sich mindestens einmal im Monat, mit 26.5% etwa doppelt so viele Männer wie Frauen (14.9%). In der Altersgruppe der 20- bis 24-Jährigen trinken 38.2% mindestens einmal im Monat punktuell risikoreich .

                </>
            )
        }
    },
    evaluation: {
        title: ' So viel und oft trinken Sie im Vergleich',
        userMarker: 'Sie sind hier.',
        frequency: [
            'Täglich',
            '3 bis 6 Tagen pro Woche',
            '1 bis 2 Tagen pro Woche',
            '< 1 Tag pro Woche',
            'nie'
        ],
        chart1: {
            title: 'So viel Standardgläser Alkohol pro Woche trinken Sie…',
            sub: ['im Vergleich zu den ', ' Teilnehmerinnen und Teilnehmern'],
            gender: ['Männer', 'Frauen'],
            key: [
                'Anzahl der alkoholischen Standardgläser pro Woche',
                'Anzahl der Teilnehmer',
                'Anzahl der Teilnehmerinnen'
            ]
        },
        chart2: {
            title: 'So häufig trinken Sie',
            sub: ['im Vergleich zu den ', ' Teilnehmerinnen und Teilnehmern'],
            gender: ['Männer', 'Frauen']
        },
        chart3: {
            title: 'So häufig trinken Sie im Vergleich zur Schweizer Bevölkerung',
            sub: ['Daten vom Bundesamt für Statistik'],
            gender: ['Männer', 'Frauen']
        },
        source: [
            'Quellen: ',
            <>
                <a href='https://www.bfs.admin.ch/bfs/de/home/statistiken/gesundheit/determinanten/alkohol.html'>
                    Bundesamt für Statistik
                </a>
                ,{' '}
                <a href='https://www.suchtschweiz.ch/' target={'_blank'}>
                    suchtschweiz.ch
                </a>
            </>
        ]
    },
    footer: {
        questions: [
            'Wie informativ war der Beitrag?',
            'Wie unterhaltsam war er?',
            'Wie gut funktionierte die technische Umsetzung?'
        ],
        credits: [
            ['Konzeption und Umsetzung', 'Marc Brupbacher, Sebastian Broschinski']
        ]
    }
}
